angular
	.module("ATMGUser", [])
	.factory("User", UserFactory)

UserFactory.$inject = [
	'ApiCustomer',
	'$q',
	'AddressBook',
	'MyAccountService',
	'$location',
	'$rootScope',
	'Cart',
	'Checkout',
	'$localStorage'
]

function UserFactory (Customer, $q, AddressBook, MyAccount, $location, $rootScope, Cart, Checkout, $storage) {

	var userData = {
		userDetails: {},
		billingAddress: {
			account_credit_hold: 'N' // to allow non logged users to see the add to cart btn
		},
		availablePaymentMethods: ['Prepay'],
		Cart: Cart,
		Checkout: Checkout
	}

	function init() {

		userData.billingAddress = "loading";
		var defer = $q.defer();

		// NOTE Cart must be quickinited ONLY if the destination is not checkout page. That applies in case of urlbacks
		if (!/checkout.*/.test( $location.path() ) && !/confirmation.*/.test($location.path())) {
			Cart.quickInit();
		}

		if ($storage.user) {
			userData.userDetails = $storage.user
		} else {
			Customer.fetchUserData()
				.then(response => {
					userData.userDetails = response.data.data
				})
				.catch(reason => {
					defer.reject(reason)
				})
		}

		Customer.getBillingAddress()
			.then(response =>  {
				let payload = response.data.data
				if (payload.account_credit_hold !== "N" ) {
					payload.errorMsg = response.warning[0]
				}
				userData.billingAddress = payload

				// extend payment informations if applicable
				if ( angular.isDefined( payload.payment_terms ) && payload.payment_terms.match("Net") ) {
					userData.availablePaymentMethods.push("NetTerms")
				}
			})
			.catch(reason => {
				defer.reject( reason );
			})


			return defer.promise
	}

	function cleanup() {
		delete $storage.user;
		userData = {
			userDetails: {},
			billingAddress: undefined,
			availablePaymentMethods: ["Prepay"],
			// Cart: Cart,
			Cart: Cart,
			Checkout: Checkout
		};

		Cart.reset()
		Checkout.reset();

		// Cart.cleanup();
		MyAccount.cleanup();
	}

	return {
		init: init,
		cleanup: cleanup,
		setUserDetails: function( userDetails ) {
			userData.userDetails = userDetails;
		},
		getFullName: function() {
			var first_name = userData.userDetails.first_name || "";
			var last_name = userData.userDetails.last_name || "";
			var full_name =  first_name + " " + last_name;
			if ( full_name === " " ) {
				return false;
			}
			return full_name
		},
		getUserData: function() {
			return userData
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/modules/ATMGUser/ATMGUser.js